import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import formImg from '../images/form-bg.png'
import { Region } from '../types/regions';
import { sendOTP } from '../services/otp-service';

const IndividualForm = (props: { regions: Region[], setLoading: (loadingState: boolean) => void }) => {

    const navigate = useNavigate()

    const next = async (data: {
        firstName: string;
        lastName: string;
        email: string;
        region: string;
    }) => {
        try {
            props.setLoading(true)
            const result = await sendOTP(data.email)
            console.log(result, 'result')
            if (result.status) {
                navigate('/verification', { state: { ...data, account_type: 'individual' } })
            }
            else {
                window.alert('An error occured while trying to send OTP')
            }
            props.setLoading(false)
        } catch (error) {
            console.log(error)
            props.setLoading(false)
        }
    }

    const regionsList = props.regions.map((item: Region) => {
        return (
            <option key={item.id} value={item.id}>{item.full_name}</option>
        )
    })

    return (
        <Formik
            initialValues={{ firstName: '', lastName: '', email: '', region: '', policy: false }}
            validationSchema={Yup.object({
                firstName: Yup.string()
                    .matches(/^[A-Za-z ]+$/, 'Name cannot contain digits and special characters')
                    .min(2, 'Too short')
                    .max(70, 'Too long')
                    .required('First name cannot be empty'),
                lastName: Yup.string()
                    .matches(/^[A-Za-z ]+$/, 'Name cannot contain digits and special characters')
                    .min(2, 'Too short')
                    .max(70, 'Too long')
                    .required('Last name cannot be empty'),
                email: Yup.string().email('Enter a valid email address').required('Email cannot be empty'),
                region: Yup.number().required('Select a region'),
                policy: Yup.boolean()
                    .required('You must accept the terms and conditions')
                    .oneOf([true], 'You must accept the terms and conditions.'),
            })}
            onSubmit={(values) => {
                console.log(values)
                next(values)
            }}
        >{(props) => (
            <Form className="flex flex-col gap-10 pb-16 bg-no-repeat min-h-[60vh] items-center justify-center bg-cover bg-center" style={{ backgroundImage: `url(${formImg})` }}>
                <div className="flex flex-col items-center w-11/12 bg-white mx-auto rounded-lg py-16 shadow-box2 gap-10">
                    <div className="w-10/12 flex flex-col gap-10 justify-center">
                        <div id='personal-info' className="flex flex-col gap-7">
                            <p className="font-poppins font-medium text-xl">Personal Information</p>
                            <div className="flex max-[768px]:flex-col gap-3">
                                <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                    {/* <label htmlFor="firstName" className="font-semibold text-[#656565]">First Name <span className="text-red-500 ">*</span></label> */}
                                    <Field name="firstName" placeholder='First Name *' type="text" className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.firstName && props.touched.firstName && 'border border-red-500'}`} />
                                    <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="firstName" /></p>
                                </div>
                                <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                    {/* <label htmlFor="lastName" className="font-semibold text-[#656565]">Last Name <span className="text-red-500 ">*</span></label> */}
                                    <Field name="lastName" placeholder='Last Name *' type="text" className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.lastName && props.touched.lastName && 'border border-red-500'}`} />
                                    <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="lastName" /></p>
                                </div>
                            </div>
                            <div className="flex max-[768px]:flex-col gap-3">
                                <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                    {/* <label htmlFor="email" className="font-semibold text-[#656565]">Email ID <span className="text-red-500 ">*</span></label> */}
                                    <Field name="email" placeholder='Email *' type="text" className={`bg-[#F5F8FA] border border-[#CBD6E2] py-2.5 px-2 rounded-md ${props.errors.email && props.touched.email && 'border border-red-500'}`} />
                                    <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="email" /></p>
                                </div>
                                <div className="flex flex-col gap-1 text-sm font-poppins flex-1">
                                    {/* <label htmlFor="region" className="font-semibold text-[#656565]">Region/Country<span className="text-red-500 ">*</span></label> */}
                                    <Field name="region" placeholder='Region/Country *' as='select' className={`bg-[#F5F8FA] ${props.values.region === "" && 'text-[#A7A7A7]'} h-[42px] border ${props.errors.region && props.touched.region && 'border border-red-500'} border-[#CBD6E2] py-2.5 px-2 rounded-md `} >
                                        <option value="" hidden disabled className="text-[#A7A7A7]">Region/Country *</option>
                                        {regionsList}
                                    </Field>
                                    <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name="region" /></p>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <div className="flex gap-3 items-center ">
                                <Field type='checkbox' name="policy" className="w-4 h-4" />
                                <label htmlFor="">By clicking here, you acknowledge that you have read the <span className="text-[#1D58E2] cursor-pointer">Privacy Policy</span> and agree to the <span className="text-[#1D58E2] cursor-pointer">Terms of Service</span></label>
                            </div>
                            <p className='text-red-500 text-xs font-poppins font-normal'><ErrorMessage name='policy' /></p>
                        </div>
                        <button type="submit" className="px-10 py-2 bg-[#1D58E2] w-fit text-white mx-auto font-inter font-medium text-lg hover:bg-[#D2232A]">Next</button>
                    </div>
                </div>
            </Form>)}
        </Formik>
    )
}

export default IndividualForm